import "./atrapameSiPuedes.css";

import facebookLogo from "../assets/images/atrapame-si-puedes/facebook-logo.svg";
import iconPopper from "../assets/images/atrapame-si-puedes/popper.svg";
import instagramLogo from "../assets/images/atrapame-si-puedes/instagram-logo.svg";
import istotipo_bicolor from "../assets/images/sorteo-mensual/istotipo_bicolor.gif";
import {redeemPromo} from "./Infrastructure/redeemPromo";
import sadFace from "../assets/images/atrapame-si-puedes/akar-icons_face-sad.svg";
import {useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";

export const RedeemView = ({
  promoState,
  openRedeemModal,
  setPromoState,
  toggleTermModal,
}) => {
  const {t} = useTranslation();
  const [searchParams] = useSearchParams();
  let accessToken = searchParams.get("token");

  const {alreadyTaken, expiredPromo, loadingPromo} = promoState;

  const isDisableButton = alreadyTaken || loadingPromo;

  const navigateInstagram = () => {
    window.navigation.postMessage(
      "web,https://www.instagram.com/petroprix_es/,,,"
    );
  };
  const navigateFacebook = () => {
    window.navigation.postMessage("web,https://www.facebook.com/petroprix/,,,");
  };

  return (
    <div className="asp-promo-card">
      {loadingPromo === true ? (
        <div className="asp-loading-container">
          <img
            src={istotipo_bicolor}
            alt="loading..."
            width="100"
            height="100"
          />
        </div>
      ) : (
        <>
          <img
            className={`asp-card-icon${alreadyTaken && "-take"}`}
            src={alreadyTaken ? sadFace : iconPopper}
            alt="Icon Popper"
          />
          <h3 className="asp-card-title">{t("atrapaqr.redeemView.title")}</h3>
          {alreadyTaken ? (
            <>
              <div className="asp-card-text-container">
                <p className="asp-card-text asp-card-text-bold">
                  {expiredPromo
                    ? t("atrapaqr.redeemView.expiredBoldText")
                    : t("atrapaqr.redeemView.takenBoldText")}
                </p>
                <p className="asp-card-text">
                  {expiredPromo
                    ? t("atrapaqr.redeemView.expiredText")
                    : t("atrapaqr.redeemView.takenText")}
                </p>
              </div>
              <div className="asp-card-logos-container">
                <img
                  onClick={navigateInstagram}
                  className={`asp-card-icon-social-media`}
                  src={instagramLogo}
                  alt="Instagram Logo"
                />
                <img
                  onClick={navigateFacebook}
                  className={`asp-card-icon-social-media`}
                  src={facebookLogo}
                  alt="Facebook Logo"
                />
              </div>
            </>
          ) : (
            <>
              <div className="asp-card-text-container">
                <p className="asp-card-text">
                  {t("atrapaqr.redeemView.successText1")}
                </p>
                <p className="asp-card-text">
                  {t("atrapaqr.redeemView.successText2")}
                </p>
                <p className="asp-card-text">
                  {t("atrapaqr.redeemView.successText3")}
                </p>
              </div>
            </>
          )}
          {expiredPromo === false ? (
            <>
              <button
                className="asp-card-button"
                onClick={() =>
                  redeemPromo(accessToken, setPromoState, openRedeemModal)
                }
                disabled={isDisableButton}
              >
                {t("atrapaqr.redeemView.button")}
              </button>
              <p className="asp-card-terms">
                {t("atrapaqr.redeemView.terms.text1")}
                <span className="asp-card-terms-span" onClick={toggleTermModal}>
                  {t("atrapaqr.redeemView.terms.textBold")}
                </span>
                {t("atrapaqr.redeemView.terms.text2")}
              </p>
            </>
          ) : null}
        </>
      )}
    </div>
  );
};
